'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('profile', {
      url: '/profile',
      template: '<profile></profile>'
    });
}



// WEBPACK FOOTER //
// ./client/app/profile/profile.routes.js